/**
 * OpeningPoster - "Åpningsplakat" overlay
 * Transparent background for chromakey use over webcam/video
 * Enter: staggered animations (logo, text, sponsor appear one by one)
 * Exit: whole card slides down as one unit — NO changes to internal elements
 */

import { TravparkLogo } from './TravparkLogo';

export function OpeningPoster({ raceDayText, mainText, isVmix, sommertravetMode, useWebcam, posterLeaving }) {
  // Enter classes are set ONCE and never removed — exit is handled entirely by the card wrapper
  return (
    <div
      data-testid="opening-poster"
      style={{
        backgroundColor: 'transparent',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      {/* Fullscreen wrapper — whole card fills entire viewport */}
      <div
        data-testid="opening-poster-card"
        className={posterLeaving ? 'poster-exit' : ''}
        style={{
          width: '100vw',
          height: '100vh',
          position: 'relative',
          zIndex: 1,
        }}
      >
        {/* Inner card — enter animation, never changes class */}
        <div
          className="weather-card-enter"
          style={{
            backgroundColor: '#050F23',
            width: '100%',
            height: '100%',
            border: 'none',
            borderRadius: 0,
            padding: 'clamp(60px, 8vh, 140px) clamp(80px, 10vw, 200px)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 'clamp(28px, 4vh, 60px)',
            overflow: 'hidden',
            boxSizing: 'border-box',
          }}
        >
          {/* Logo — enter animation, class stays forever */}
          <div className="weather-header-enter" style={{ display: 'flex', justifyContent: 'center' }}>
            <TravparkLogo height={320} sommertravetMode={sommertravetMode} animated style={{ filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.4))' }} />
          </div>

          <div style={{ width: '50%', maxWidth: '900px', height: '3px', background: 'linear-gradient(90deg, transparent, var(--theme-gradient-line), transparent)' }} />

          {/* Main text — enter animation, class stays forever */}
          <div
            data-testid="opening-poster-main-text"
            className="weather-col-enter weather-col-enter-1"
            style={{
              fontFamily: "'Barlow Condensed', sans-serif",
              fontSize: 'clamp(4.5rem, 7vw, 8rem)',
              fontWeight: 700,
              color: '#FFFFFF',
              textTransform: 'uppercase',
              letterSpacing: '0.06em',
              textAlign: 'center',
              textShadow: '0 2px 8px rgba(0,0,0,0.4)',
              lineHeight: 1.05,
            }}
          >
            {mainText || 'Tipssendingen starter snart'}
          </div>

          {raceDayText && (
            <div
              data-testid="opening-poster-raceday-text"
              className="weather-col-enter weather-col-enter-2"
              style={{
                fontFamily: "'Barlow Condensed', sans-serif",
                fontSize: 'clamp(3rem, 4.5vw, 5rem)',
                fontWeight: 600,
                color: 'var(--theme-accent)',
                textTransform: 'uppercase',
                letterSpacing: '0.04em',
                textAlign: 'center',
                textShadow: '0 2px 6px rgba(0,0,0,0.3)',
              }}
            >
              {raceDayText}
            </div>
          )}

          <div style={{ width: '35%', maxWidth: '700px', height: '2px', background: 'linear-gradient(90deg, transparent, var(--theme-gradient-line-subtle), transparent)' }} />

          <div
            className="weather-col-enter weather-col-enter-3"
            style={{
              display: 'flex', justifyContent: 'center', alignItems: 'center',
              backgroundColor: '#FFFFFF', borderRadius: '16px',
              padding: 'clamp(20px, 2vh, 32px) clamp(40px, 5vw, 80px)',
              boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
            }}
          >
            <img src="/assets/kvernland-bil.png" alt="Kvernland Bil" data-testid="opening-poster-sponsor-logo" style={{ height: 'clamp(120px, 14vh, 200px)', objectFit: 'contain' }} />
          </div>
        </div>
      </div>
    </div>
  );
}
